import { APIURL } from "../models/api-base";
import {
    apiUrl_lives_comments_reports,
    apiUrl_eco_reports,
} from "../models/api-urls";
import fetchService from "../modules/APIService";

class Service extends fetchService {
    constructor() {
        super(APIURL);
    }

    //LIVES COMMENTS REPORTS
    getLiveCommentReports = async (page, pageSize) => {
        const response = await this.get(
            `${apiUrl_lives_comments_reports}?page=${page}&pageSize=${pageSize}`
        );
        return response;
    };

    //ECO REPORTS POSTS AND COMMENTS
    getEcoReports = async (page = 1, pageSize = 20, from = "", to = "") => {
        try {
            const params = new URLSearchParams();
            params.set("page", String(page));
            params.set("pageSize", String(pageSize));
            if (from) params.set("from", from);
            if (to) params.set("to", to);

            const res = await this.get(`${apiUrl_eco_reports}?${params.toString()}`);
            // axios -> res.data
            return res.data;
        } catch (error) {
            console.error("[eco-report] Error en la petición:", error);
            throw error;
        }
    };

    //DETAILS POSTS ECO REPORT
    getEcoReportDetails = async (postId) => {
        const response = await this.get(`${apiUrl_eco_reports}/${postId}/post/detail`);
        return response;
    };

    //DETAILS COMMENTS ECO REPORT
    getEcoReportCommentsDetails = async (postId) => {
        const response = await this.get(
            `${apiUrl_eco_reports}/${postId}/comment/detail`
        );
        return response;
    };

    //DELETE ECO REPORT (POST OR COMMENT)
    deleteEcoPostOrCommentReport = async (reportId, type) => {
        console.log("Deleting report:", reportId, "of type:", type);
        const response = await this.delete(`${apiUrl_eco_reports}/${reportId}`, type);
        return response;
    };
}

const LiveCommentsReportService = new Service();

export default LiveCommentsReportService;
